/*
 *  Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Typography from "@mui/material/Typography";
import { Box, Stack } from "@mui/material";
import { scrollToAnchor } from "../../../../../../theme/commonStyle";
import ZipperTeaserWbs from "./ZipperTeaserWbs";
import dataInquiryIcon from "../../../../../../assets/icons/landingpage/wbs/IconDataInquiry";
import IconWritingWbs from "../../../../../../assets/icons/landingpage/wbs/IconWritingWbs";
import IconGeldEinfordernWbs from "../../../../../../assets/icons/landingpage/wbs/IconMoneyEnforceWbs";

const HowItWorksSectionSchufaWbs = () => {
  return (
    <>
      <Box>
        <Box sx={scrollToAnchor} id="so-funktioniert-es" />
        <Typography variant={"h2"} textAlign={"center"}>
          So einfach funktioniert es
        </Typography>
      </Box>
      <Stack direction={"row"} justifyContent={"center"}>
        <ZipperTeaserWbs
          teaserRows={[
            {
              headline: "Angaben zum Vertrag",
              subText: "Du machst kurz Angaben zu deinem Mobilfunkvertrag und beauftragst uns für die Prüfung.",
              image: IconWritingWbs,
            },
            {
              headline: "SCHUFA / CRIF-Anfrage",
              subText: "Wir fordern eine SCHUFA / CRIF-Auskunft für dich an und prüfen, ob der Mobilfunkanbieter deine Daten weitergegeben hat.",
              image: dataInquiryIcon,
            },
            {
              headline: "Schadensersatz einfordern",
              subText: "Es wurden Daten weitergegeben? Dann fordern wir Schadensersatz für dich!",
              image: IconGeldEinfordernWbs,
            },
          ]}
        />
      </Stack>
    </>
  );
};

export default HowItWorksSectionSchufaWbs;
